.grid {
  display: grid;
}

.cell {
  padding: 12px 16px;
  border-right: 1px solid var(--c-border);
  border-bottom: 1px solid var(--c-border);
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.label {
  font-size: 12px;
  color: var(--c-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.value {
  font-family: var(--font-mono);
  font-size: var(--text-headline);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.note {
  font-size: var(--text-micro);
  color: var(--c-text-tertiary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pos {
  color: var(--c-positive);
}

.neg {
  color: var(--c-negative);
}

.fact {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px;
  border-radius: 10px;
  background: var(--c-surface-sunken);
  min-width: 0;
}

.factLabel {
  font-size: var(--text-micro);
  color: var(--c-text-tertiary);
}

.factValue {
  font-family: var(--font-mono);
  font-size: var(--text-callout);
  font-weight: 600;
  overflow-wrap: anywhere;
}

.factGrid {
  display: grid;
  gap: 10px;
}

.big {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
}

.bigValue {
  font-family: var(--font-mono);
  font-size: var(--text-display);
  font-weight: 600;
  letter-spacing: -1px;
}

.bigUnit {
  font-family: var(--font-mono);
  font-size: var(--text-subtitle);
  font-weight: 500;
  color: var(--c-text-secondary);
}

.kv {
  margin: 0;
  display: flex;
  flex-direction: column;
}

.kvRow {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0;
  border-bottom: 1px solid var(--c-border);
  font-size: var(--text-caption);
}

.kvRow:last-child {
  border-bottom: 0;
}

.kvRow dt {
  color: var(--c-text-secondary);
}

.kvRow dd {
  margin: 0;
  text-align: right;
  color: var(--c-text-primary);
}

.section {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--text-micro);
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--c-text-tertiary);
}

.sectionAside {
  margin-left: auto;
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
  font-size: 12px;
}
